import { darken, lighten, Theme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

const availableBackgroundColor = "#EFEFFA";
const customBackgroundColor = lighten("#A6B1F8", 0.4);

export const useRiskAreaTemplateCardStyles = (theme: Theme, image: string, isAdded: boolean, isCustom: boolean) => {
    const backgroundColor = isAdded ? theme.palette.grey[100] : isCustom ? customBackgroundColor : availableBackgroundColor;

    return createSxStyles({
        card: {
            borderRadius: "14px",
            padding: 2,
            height: 130,
            backgroundImage: `url("${image}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-15px -15px",
            backgroundSize: "110px",
            backgroundColor,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
                cursor: isAdded ? "default" : "pointer",
                backgroundColor: isAdded ? backgroundColor : darken(backgroundColor, 0.03),
            },
        },
    });
};
